import { useEffect, useRef, useState } from 'react';
export function useRealtime(session) {
    const [status, setStatus] = useState('idle');
    const [avatarStreamUrl, setAvatarStreamUrl] = useState();
    const wsRef = useRef(null);
    useEffect(() => {
        if (!session?.realtimeWsUrl)
            return;
        setStatus('connecting');
        const ws = new WebSocket(session.realtimeWsUrl);
        wsRef.current = ws;
        ws.onopen = () => setStatus('connected');
        ws.onerror = () => setStatus('error');
        ws.onclose = () => setStatus('idle');
        ws.onmessage = (event) => {
            try {
                const msg = JSON.parse(event.data);
                if (msg.type === 'connected' && msg.payload?.avatar_stream_player_url) {
                    setAvatarStreamUrl(msg.payload.avatar_stream_player_url);
                }
            }
            catch {
                // ignore malformed frames
            }
        };
        const ping = window.setInterval(() => {
            if (ws.readyState === WebSocket.OPEN) {
                ws.send(JSON.stringify({ type: 'ping' }));
            }
        }, 45000);
        return () => {
            window.clearInterval(ping);
            ws.close();
            wsRef.current = null;
        };
    }, [session?.realtimeWsUrl]);
    useEffect(() => {
        if (session?.avatarStreamPlayerUrl) {
            setAvatarStreamUrl(session.avatarStreamPlayerUrl);
        }
    }, [session?.avatarStreamPlayerUrl]);
    return { status, avatarStreamUrl };
}
